import {
  type ApiErrorResponse,
  type UseAppMutationOptions
} from '@libs/data-access/queries'
import { useMutation } from '@tanstack/react-query'

import type { CreateShiftOptions } from '../shift.api'
import { createShift } from '../shift.api'

export const useCreateShift = (
  mutationOptions?: UseAppMutationOptions<
    null,
    ApiErrorResponse,
    CreateShiftOptions
  >
) => {
  return useMutation<null, ApiErrorResponse, CreateShiftOptions>({
    ...mutationOptions,
    mutationFn: opts => createShift(opts),
    onSuccess: (...args) => {
      mutationOptions?.onSuccess?.(...args)
    }
  })
}
